import { render } from "./EntityList.vue?vue&type=template&id=6b11cf00&scoped=true&ts=true"
import script from "./EntityList.vue?vue&type=script&lang=ts"
export * from "./EntityList.vue?vue&type=script&lang=ts"

import "./EntityList.vue?vue&type=style&index=0&id=6b11cf00&lang=scss&scoped=true"

import exportComponent from "/var/www/kun/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b11cf00"]])

export default __exports__